import type { PortfolioBacktest, PositionSizeRule } from '@einhaus/project314-types';

export interface BaselineDeploymentSelection {
    strategyId: number;
    tradingProfileId: number;
    optionBuyingStrategyIds: readonly number[];
    exitCandidateIds: readonly number[];
}

const ids = (values: readonly number[] | undefined): string => [...new Set(values ?? [])].sort((a, b) => a - b).join(',');
export function baselineMatchesDeployment(
    backtest: Pick<PortfolioBacktest, 'strategiesSubscribed'>,
    selection: BaselineDeploymentSelection
): boolean {
    const frozen = backtest.strategiesSubscribed.find((row) => row.id === selection.strategyId);
    return Boolean(
        frozen &&
        frozen.tradingProfileId === selection.tradingProfileId &&
        ids(frozen.optionBuyingStrategyIds) === ids(selection.optionBuyingStrategyIds) &&
        ids(frozen.exitCandidateIds) === ids(selection.exitCandidateIds)
    );
}

const sizingKey = (rules: readonly PositionSizeRule[]): string =>
    rules
        .map((rule) => `${rule.type}|${[...rule.entityTypes].sort().join(',')}|${Number(rule.value)}`)
        .sort()
        .join(';');

export function baselineSizingMatches(
    backtest: Pick<PortfolioBacktest, 'strategiesSubscribed' | 'settings'>,
    strategyId: number,
    effectiveRules: readonly PositionSizeRule[]
): boolean | null {
    const frozen = backtest.strategiesSubscribed.find((row) => row.id === strategyId);
    const rules = frozen?.portfolioBacktestPositionSizeRules ?? backtest.settings.positionSizeRules;
    return rules ? sizingKey(rules) === sizingKey(effectiveRules) : null;
}
